import { render } from "./CurrencyRang.vue?vue&type=template&id=2b0abed2&ts=true"
import script from "./CurrencyRang.vue?vue&type=script&lang=ts"
export * from "./CurrencyRang.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__